import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

export const Span = styled.span`
  position: absolute;
  right: 0.5rem;
  bottom: ${({ theme }) => `-${theme.spacing.one_2}`};

  margin-top: ${({ theme }) => theme.spacing.zero_1};

  text-align: right;
`;

export const ForgotPasswordLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};

  font-size: ${({ theme }) => theme.fontSize.sm};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
`;
